// src/app/layout/CoreContextBadge.tsx
import { ShieldCheck } from 'lucide-react';

/**
 * Identifies which acting-as context this app always represents.
 * Static by design: this app maps 1:1 to core-permissions'
 * `ContextType = 'super_admin'` (see that package's own doc — one
 * standalone app per context), so there is no context switcher to
 * back a dynamic label. If a real UserContext-resolution flow lands
 * later, this can read that context's display name instead — not part
 * of this layout-only phase.
 */
export function CoreContextBadge() {
  return (
    <span
      title="Super Admin"
      className="flex shrink-0 items-center gap-1.5 rounded-full border border-[var(--vania-border-glass,rgba(255,255,255,0.1))] bg-[var(--vania-surface-2,rgba(255,255,255,0.05))] px-2.5 py-1 text-xs font-medium text-[var(--vania-text-secondary,#a6acb8)]"
    >
      <ShieldCheck size={13} strokeWidth={2.2} className="text-[var(--vania-accent-violet,#7c6cff)]" />
      مدیر کل
    </span>
  );
}
